import loadable from '@loadable/component'

const LoadableGAPIProvider = loadable(() => import('./GAPIProviderWrapper'))

export default LoadableGAPIProvider
